var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84705 24.9663C1.84705 20.0581 5.94665 16.0792 14.3241 16.0792C22.7016 16.0792 26.8012 20.0581 26.8012 24.9663C26.8012 25.7472 26.2316 26.3802 25.529 26.3802H3.11922C2.41662 26.3802 1.84705 25.7472 1.84705 24.9663Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.003 6.10017C19.003 8.68486 16.9082 10.7802 14.3241 10.7802C11.74 10.7802 9.64521 8.68486 9.64521 6.10017C9.64521 3.51547 11.74 1.42017 14.3241 1.42017C16.9082 1.42017 19.003 3.51547 19.003 6.10017Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.f662ac8d9e026d8c5b182ebac2d4d47d.svg";
export { ForwardRef as ReactComponent };